import { render, staticRenderFns } from "./RequestNotificationPopUp.html?vue&type=template&id=3a275356&scoped=true&"
import script from "./RequestNotificationPopUp.js?vue&type=script&lang=js&"
export * from "./RequestNotificationPopUp.js?vue&type=script&lang=js&"
import style0 from "./RequestNotificationPopUp.scss?vue&type=style&index=0&id=3a275356&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a275356",
  null
  
)

export default component.exports